import { Theme } from '@mui/material/styles';

export const darkSurfaceColors = {
  background: '#181818',
  border: '#303030',
  text: '#f7f7f7',
} as const;

export const getCardSurfaceSx = (theme: Theme, isDark: boolean) =>
  isDark
    ? {
        backgroundColor: darkSurfaceColors.background,
        border: `1px solid ${darkSurfaceColors.border}`,
        color: darkSurfaceColors.text,
      }
    : { border: `1px solid ${theme.palette.divider}` };
